export default function StockField({
  label,
  children,
  action,
}: {
  label: string;
  children: React.ReactNode;
  action?: React.ReactNode;
}) {
  return (
    <div>
      <p className="flex items-center gap-1 text-xs font-semibold uppercase tracking-wide text-gray-500">
        <span>{label}</span>
        {action}
      </p>
      <div className="mt-1 text-sm text-gray-900">{children}</div>
    </div>
  );
}
